/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Aggregated hooks metrics for a single user
 */
export type HooksUserSummary = {
  /**
   * Total number of hook events for this user
   */
  eventCount: number;
  /**
   * Number of failed tool completions (PostToolUseFailure events)
   */
  failureCount: number;
  /**
   * Failure rate as a decimal (0.0 to 1.0)
   */
  failureRate: number;
  /**
   * Number of successful tool completions (PostToolUse events)
   */
  successCount: number;
  /**
   * Number of unique tools used by this user
   */
  uniqueTools: number;
  /**
   * User email address
   */
  userEmail: string;
};

/** @internal */
export const HooksUserSummary$inboundSchema: z.ZodMiniType<
  HooksUserSummary,
  unknown
> = z.pipe(
  z.object({
    event_count: z.int(),
    failure_count: z.int(),
    failure_rate: z.number(),
    success_count: z.int(),
    unique_tools: z.int(),
    user_email: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "event_count": "eventCount",
      "failure_count": "failureCount",
      "failure_rate": "failureRate",
      "success_count": "successCount",
      "unique_tools": "uniqueTools",
      "user_email": "userEmail",
    });
  }),
);

export function hooksUserSummaryFromJSON(
  jsonString: string,
): SafeParseResult<HooksUserSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => HooksUserSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'HooksUserSummary' from JSON`,
  );
}
